export enum AutomotiveEntityType {
  CancelledDeal = 17100,
  ForwardOrderOrFreeReleaseNumber = 17101
}